import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { MiscContentDetailsPagePrefetchedDataProps } from 'src/app/pages/misc/pageContext';
import { MiscContentDetailsPageContextProvider, prefetchPageContext } from 'src/app/pages/misc/pageContext';

import { Layout } from '../layout';

import { MiscContentDetailsErrorHandler } from './ErrorHandler';

export const MiscContentDetails = withPrefetchedData(
	function MiscContentDetails({ prefetchedData }: MiscContentDetailsPagePrefetchedDataProps) {
		const { countryCode, slug } = useKnownAvailableParams<{ countryCode: string; slug: string }>();

		return (
			<MiscContentDetailsPageContextProvider
				slug={slug}
				countryCode={countryCode}
				prefetchedData={prefetchedData}
				errorHandler={MiscContentDetailsErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</MiscContentDetailsPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.countryCode!, context.params.slug!, context),
	},
);
